<template>
    <div id="test-order-result-container">
        <b-row>
            <b-col class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle"
                    v-bind:titlePrefix="$t('TestOrderResult.Title')"
                    v-bind:titleRef="'titleElementTestOrderResult'"
                    v-bind:patientCode="this.$route.params.id"
                >
                </MdTitleRegInfo>

                <div
                    class="alert alert-fill-warning d-flex align-items-center m-3"
                    role="alert"
                    v-if="isReadOnly"
                >
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <div class="grid-margin stretch-card">
            <div class="card activeCard">
                <div class="card-body">
                    <div class="d-flex align-items-start justify-content-between">
                        <h6
                            v-b-toggle="'OrdertoFill'"
                            class="card-title flex-grow lower-line text-truncate"
                        >
                            {{ $t('TestOrderResult.OrderViewResult') }}
                        </h6>
                        <i
                            class="mdi mdi-arrow-right-drop-circle text-corporate"
                            style="cursor: pointer"
                            v-on:click="GotoMedByBox"
                        ></i>
                    </div>

                    <div class="float-left col-md-3 text-muted p-item">
                        <small>{{ $t('Shared.Date') }}</small
                        ><br />
                        <b>{{ orderDate }}</b>
                    </div>

                    <div class="float-left col-md-3 text-muted p-item">
                        <small>{{ $t('Shared.Name') }}</small>
                        <br />
                        <b>{{ this.selectedTestOrder.testName }}</b>
                        <br />
                    </div>

                    <div class="float-left col-md-3 text-muted p-item">
                        <small>{{ $t('Shared.Code') }}</small
                        ><br />
                        <b>{{ this.selectedTestOrder.testCode }}</b>
                    </div>

                    <div class="float-left col-md-3 text-muted p-item">
                        <small>{{ $t('Shared.Location') }}</small
                        ><br />
                        <b>{{ this.selectedTestOrder.locationName }}</b>
                    </div>
                </div>
            </div>
        </div>

        <MdTitle
            v-bind:Text="$t('Shared.PatientInfo')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <div class="IncidentContainerBox noNum mt-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between">
                                    <h6
                                        v-b-toggle="'InfoBoxs'"
                                        class="card-title flex-grow lower-line text-truncate"
                                    >
                                        {{ patientInfo.patientName }} - {{ PatientCode }} -
                                        {{ $t('Shared.Dob') }} {{ patientInfo.dob }}
                                        {{ patientInfo.ageFormatted }} -
                                        {{ $t('Shared.Weight') + label('Weightlbs') }}
                                        {{ patientInfo.weight }} -
                                        {{ $t('Shared.Height') + label('Heightft') }}
                                        {{ patientInfo.heights }}
                                    </h6>
                                    <b-button
                                        v-on:click="DoReport()"
                                        style="position: relative; top: -4px;"
                                        class="repDateNotesBtn mx-2"
                                        v-b-tooltip.hover
                                        :title="$t('MdPatientInfoBox.CurrentFaceSheet')"
                                    >
                                        {{ $t('Shared.FS') }}
                                    </b-button>
                                </div>

                                <b-collapse visible id="InfoBoxs" class="small-info ml-2"
                                    ><small>{{
                                        $t('modalMarsMed.clickTitleTextPatient')
                                    }}</small></b-collapse
                                >
                                <b-collapse id="InfoBoxs">
                                    <div class="card activeCard">
                                        <div class="container-mars">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <div class="row patPhoto-container">
                                                        <div class="col-md-1 patPhoto">
                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        patientInfo.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.MarsAlerts'
                                                                    )}: ` + patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ` / ` +
                                                                        $t('Shared.PatientSpecialPrecautions') +
                                                                        ': ' +
                                                                        patientInfo.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        patientInfo.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ' / ' +
                                                                        `${$t(
                                                                            'Shared.PatientSpecialPrecautions'
                                                                        )}: ` +
                                                                        patientInfo.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <img
                                                                v-if="patientInfo.contents"
                                                                v-bind:src="
                                                                    'data:image/' +
                                                                        '.' +
                                                                        patientInfo.extension +
                                                                        ';base64,' +
                                                                        patientInfo.contents
                                                                "
                                                                alt="Foto"
                                                                class="patPic img-fluid"
                                                                style="height: 100%;"
                                                            />
                                                            <!--<img v-if="(patientInfo.contents === null || patientInfo.contents === '') && patientInfo.sex === 'M'" src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">-->

                                                            <img
                                                                v-else-if="
                                                                    (patientInfo.contents ===
                                                                        null ||
                                                                        patientInfo.contents ===
                                                                            '') &&
                                                                        patientInfo.sex === 'F'
                                                                "
                                                                src="@/assets/images/faces/nopic-female.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />

                                                            <!-- <img v-if="(this.patientInfo.contents === null || this.patientInfo.contents === '') && this.patientInfo.sex === ''" src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">-->
                                                            <img
                                                                v-else
                                                                src="@/assets/images/faces/nopic-male.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />
                                                        </div>
                                                        <div class="col-md-11">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientName')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        patientInfo.patientName
                                                                    }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientCode')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PatientCode }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Dob')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.dob }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Age')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        patientInfo.ageFormatted
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Gender')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.sex }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Weight') +
                                                                            label('Weightlbs')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.weight }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Height') +
                                                                            label('Heightft')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.heights }}</b>
                                                                </div>
                                                                <!--
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $tc('Shared.Program')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        medications.programName
                                                                    }}</b>
                                                                </div>
                                                                -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <MdPatientAllergies
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                            v-bind:VisibleAllergy="true"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientAllergies>
                                        <MdPatientSpecialPrecautions
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddSpecialPrecautions="
                                                'AddSpecialPrecautionMarsMed'
                                            "
                                            v-bind:VisibleSpecialPrecautions="true"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientSpecialPrecautions>
                                        <MdPatientMarsAlert
                                            v-if="PatientCode"
                                            v-bind:UseColumnDynamic="true"
                                            v-bind:ModalIdAddMarksAlert="'ModalMarsAlert'"
                                            v-bind:VisibleMarsAlert="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientMarsAlert>
                                        <MdPatientDiagnosis
                                            v-if="PatientCode"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:VisibleDiagnosis="true"
                                            v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientDiagnosis>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <MdTitle
            v-bind:Text="$t('TestOrderResult.Title')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.Date')"
                    :Model="editableItem.datePerformed"
                    @input="editableItem.datePerformed = $event"
                    :Id="'TestOrderResultDatePerformed'"
                    :Type="'date'"
                    :isRequired="true"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="isDatePerformedValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="9" md="9" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrderResult.TestFacility')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.location"
                    v-bind:isReadOnly="isReadOnly"
                >
                </MdEdit>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrderResult.Result')"
                    v-bind:Name="'TestResult'"
                    v-bind:TypeProp="'number'"
                    v-model.number="editableItem.resultNumber"
                    v-bind:isReadOnly="isReadOnly"
                    :isValid="isTestResultNumberValid"
                    :isRequired="true"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrderResult.Low')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="selectedOrderInfo.lowRange"
                    v-bind:isReadOnly="true"
                >
                </MdEdit>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.ResultType')"
                    v-bind:Options="resultTypeList"
                    v-bind:Model="editableItem.resultType"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownResultType"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('Shared.Unit')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="selectedOrderInfo.unit"
                    v-bind:isReadOnly="true"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrderResult.High')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="selectedOrderInfo.highRange"
                    v-bind:isReadOnly="true"
                >
                </MdEdit>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.Specimen')"
                    v-bind:Options="specimens"
                    v-bind:Model="editableItem.testSpecimen"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownSpecimen"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrderResult.TextResult')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.resultText"
                    v-bind:isReadOnly="isReadOnly"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('Shared.Unit')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="selectedUnit"
                    v-bind:isReadOnly="true"
                >
                </MdEdit>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrderResult.CondSpecimen')"
                    v-bind:Options="condSpecimenList"
                    v-bind:Model="editableItem.condSpecimen"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownCondSpecimen"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$tc('Shared.Note', 2)"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdMemo
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'textarea_notes'"
                    v-bind:Rows="'6'"
                    v-bind:MaxRows="'10'"
                    v-model="editableItem.comments"
                />
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBackToTestOrderResults'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="backToListing"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="saveOrEdit"
                v-bind:isReadOnly="saveButtonDisabled"
                v-bind:Name="'btn_save_test_order'"
            />
        </div>

        <DxPopup
            :visible="isReportPatientFaceSheetVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="reportTitle"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="PatientFaceSheetRep"
                :ReportName="'PatientFaceSheet'"
                :ReportTitle="reportTitle"
                :IsAnAPIReport="true"
            />
        </DxPopup>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';
import PatientService from '@/services/patient.service';
import DocumentManagementService from '@/services/documentmanagement.service';
import GlobalService from '@/services/global.service';
import TestOrderResultsService from '@/services/testorderresults.service';
import { DxPopup } from 'devextreme-vue/popup';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'TestOrderResult',
    mixins: [ShowMessage, DBFunctions, Permission],
    components: { DxPopup },
    data() {
        return {
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false,
                PatientCode: ''
            },
            RegistrationInfo: {},
            patientInfo: {},
            currentAppointmentDB: {
                guid: '',
                activitytypecode: '',
                employee: {
                    firstname: '',
                    lastname: ''
                }
            },
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            isReadOnly: false,
            PatientCode: this.$route.params.id,
            reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
            isReportPatientFaceSheetVisible: false,
            editableItem: {
                condSpecimen: '',
                resultType: '',
                resultNumber: null,
                resultText: '',
                location: '',
                comments: '',
                datePerformed: null,
                testSpecimen: '',
                testCode: '',
                recordId: `${this.$route.params.recNo}`
            },
            selectedTestOrder: {},
            selectedOrderInfo: {
                lowRange: '',
                highRange: '',
                unit: ''
            },
            mode: false,
            resultTypeList: EnumService.TestOrderResultType,
            condSpecimenList: EnumService.TestOrderResultCondSpecimen,
            specimens: [],
            isDatePerformedValid: true,
            isTestResultNumberValid: true,
            selectedUnit: '',
            OffRoute: false,
            clickBack: false,
            wasSaved: false,
            pendingChanges: false
        };
    },
    computed: {
        saveButtonDisabled() {
            if (this.isReadOnly) {
                return true;
            }

            return !this.pendingChanges;
        },
        orderDate() {
            return Utils.formatterDateTimeToString(this.selectedTestOrder.sysDate);
        }
    },
    methods: {
        backToListing() {
            this.clickBack = true;
            this.OffRoute = false;
            this.discardChanges();
        },

        discardChanges() {
            if (this.$route.name.includes('appointments-')) {
                this.$router.push({
                    name: 'appointments-test-orders',
                    params: {
                        id: this.$route.params.id,
                        actId: this.$route.params.actId
                    }
                });
            } else {
                this.$router.push({
                    name: 'clinical-test-orders',
                    params: { id: this.$route.params.id }
                });
            }
        },

        async executeAction() {
            if (!this.isReadOnly && this.pendingChanges) {
                if (this.validateRequired()) {
                    if (this.mode) {
                        await this.updateTestOrderResult();
                    } else {
                        await this.addTestOrderResult();
                    }
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );
                }
            }
        },

        async updateTestOrderResult() {
            const dataToSave = this.prepareDataToSave();
            await TestOrderResultsService.update(this.editableItem.recordId, dataToSave)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;

                        console.log(
                            'updateTestOrderResult',
                            !this.OffRoute || this.clickBack,
                            !this.OffRoute,
                            this.clickBack
                        );
                        if (!this.OffRoute || this.clickBack) {
                            this.discardChanges();
                        }

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async addTestOrderResult() {
            const dataToSave = this.prepareDataToSave();
            await TestOrderResultsService.add(dataToSave)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;

                        if (!this.OffRoute || this.clickBack) {
                            this.discardChanges();
                        }

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validateRequired() {
            this.isDatePerformedValid =
                this.editableItem.datePerformed &&
                Utils.isValidDate(this.editableItem.datePerformed);
            this.isTestResultNumberValid =
                this.editableItem.resultNumber !== null &&
                this.editableItem.resultNumber !== undefined &&
                String(this.editableItem.resultNumber).length !== 0;

            return this.isDatePerformedValid && this.isTestResultNumberValid;
        },

        prepareDataToSave() {
            let data = {
                ...this.editableItem,
                patientCode: this.$route.params.id
            };

            return data;
        },

        label(value) {
            if (value === 'Temperature') {
                return this.unitSys === 'U' ? ' (°F)' : ' (°C)';
            }

            if (value === 'Weightlbs') {
                return this.unitSys === 'U' ? ' (lbs)' : ' (Kgs)';
            }

            if (value === 'Weightoz') {
                return this.unitSys === 'U' ? ' (oz)' : ' (g)';
            }

            if (value === 'Heightft' || value === 'HeadCirin') {
                return this.unitSys === 'U' ? ' (ft)' : ' (cm)';
            }

            if (value === 'Heightin') {
                return this.unitSys === 'U' ? ' (in)' : ' (mm)';
            }

            if (value === 'SugarLevelmgdL') {
                return this.unitSys === 'U' ? ' (mg/dL)' : ' (mM)';
            }

            if (value === 'BMIlbsin2') {
                return this.unitSys === 'U' ? ' (lbs/in2)' : ' (kgs/m2)';
            }

            return '';
        },

        async clickOffRoute() {
            this.OffRoute = true;
            this.clickBack = false;
            await this.executeAction();
        },

        async saveOrEdit() {
            this.OffRoute = false;
            this.clickBack = false;
            await this.executeAction();
        },

        GotoMedByBox() {},

        changeDropDownResultType(value) {
            this.editableItem.resultType = value ? value.value : null;
        },

        changeDropDownSpecimen(value) {
            this.editableItem.testSpecimen = value ? value.value : null;
        },

        changeDropDownCondSpecimen(value) {
            this.editableItem.condSpecimen = value ? value.value : null;
        },

        DoReport() {
            let reportParams = [];
            reportParams.push({ paramName: 'PatientCodeList', paramValue: this.PatientCode });
            reportParams.push({ paramName: 'ActivePatient', paramValue: '' });
            reportParams.push({ paramName: 'ActiveAdmission', paramValue: '' });
            this.isReportPatientFaceSheetVisible = true;
            this.$refs.PatientFaceSheetRep.buildDocument(reportParams);
        },

        onHiddenReport() {
            this.isReportPatientFaceSheetVisible = false;
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename = this.currentAppointmentDB.activitytypename;
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(
                this.currentAppointmentDB.transdate
            )} ${this.currentAppointmentDB.timein}`;
        },

        PopulatePatientTitle() {
            if (this.$route.name.includes('clinical-')) {
                const {
                    dob,
                    dateFrom,
                    dateTo,
                    age,
                    programName,
                    patientName,
                    ageFormatted
                } = this.RegistrationInfo; // Destructure for easier access

                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = dob;
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }
        },

        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        },

        async registrationInfoTitleAsync() {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(
                this.$route.params.recordid
            );
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob = Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? '0' : age;
        },

        async getPatientInfo(patientCode) {
            await PatientService.get(patientCode)
                .then(response => {
                    if (response.data) {
                        this.patientInfo = response.data;
                        this.patientInfo.patientName =
                            this.patientInfo.firstname + ' ' + this.patientInfo.lastname;
                        this.patientInfo.dob = Utils.formatterDateToString(this.patientInfo.dob);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatientPhoto(patientCode) {
            await DocumentManagementService.GetPatientPhoto(patientCode)
                .then(response => {
                    if (response.data) {
                        const patientPhoto = response.data;
                        this.patientInfo.contents = patientPhoto.contents;
                        this.patientInfo.extension = patientPhoto.extension;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getSpecimenSourceAsync() {
            await GlobalService.getSpecimenType()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.specimens = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getTestOrderResultByRecordIdAsync() {
            await TestOrderResultsService.getOrCreateFromTestOrderCode(this.editableItem.recordId)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.mode = false;
                        this.selectedOrderInfo = response.data.testResultSetup;

                        if (response.data.testResult) {
                            this.editableItem = response.data.testResult;
                            this.mode = true;
                        } else {
                            this.editableItem.testCode = response.data.testOrder.testCode;
                        }

                        this.selectedTestOrder = response.data.testOrder;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        initializeBusEvent() {
            this.$nextTick(() =>
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        if (!this.isReadOnly) {
                            this.pendingChanges |= e.Changed;
                        }
                    }.bind(this)
                )
            );
        },

        initialize() {
            const promises = [
                this.PopulatePatientTitle(),
                this.GetPatientByCode(),
                this.registrationInfoTitleAsync(),
                this.getPatientInfo(this.PatientCode),
                this.getSpecimenSourceAsync()
            ];

            if (this.$route.name.includes('appointments-')) {
                promises.push(this.getCurrentAppointment());
            }

            Promise.allSettled(promises).then(() => {
                Promise.allSettled([
                    this.getPatientPhoto(this.PatientCode),
                    this.getTestOrderResultByRecordIdAsync()
                ]).then(() => this.initializeBusEvent());
            });
        }
    },

    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload);
        this.initialize();
    },

    async mounted() {
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointments-')
            ? EnumService.AppointmentItems
            : EnumService.ClinicalItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isReadOnly = this.$store.state.isTestResultsEHRReadOnly;
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
    },

    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('TestOrderResult.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.clickOffRoute();

                        if (this.wasSaved) {
                            next();
                        }
                    }
                });
        } else {
            next();
        }
    }
};
</script>
